module.exports = __webpack_public_path__ + "static/anna_hero-0b8c067b03d4ead8ab30a94846052bae.png";